import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { ElementShownAnchor } from '@hh.ru/analytics-js';
import { HSpacing, Link, Text, VSpacing } from '@hh.ru/magritte-ui';
import { makeSetStoreField } from '@hh.ru/redux-create-reducer/lib/createReducer';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import {
    AnalyticsParams,
    ResumeSearchContextAction,
    ResumeSearchContextSource,
    sendEventAction,
    sendEventElementShown,
} from 'src/components/Search/Resume/ContextVacancy/utils/analytics';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { ContextViewMode } from 'src/models/resumeSearchContext';

const setContextVacancySelectorVisible = makeSetStoreField('resumeSearchContextVacancySelectorVisible');

const TrlKeys = {
    text: 'resume.search.context.subtitleWithoutVacancy.text',
    actionSelect: 'resume.search.context.subtitleWithoutVacancy.action.select',
};

const ContextSubtitleWithoutVacancy: TranslatedComponent = ({ trls }) => {
    const dispatch = useDispatch();

    const vacancy = useSelector((state) => state.resumeSearchContext?.vacancy);
    const viewMode = useSelector((state) => state.resumeSearchContext?.viewMode);

    const employerId = useSelector((state) => state.employerId);
    const employerManagerId = useSelector((state) => state.employerManager?.id) || '';

    const analyticsParams: AnalyticsParams = useMemo(
        () => ({
            employerId,
            employerManagerId,
            hhtmSourceLabel: ResumeSearchContextSource.Title,
        }),
        [employerId, employerManagerId]
    );

    if (vacancy || viewMode !== ContextViewMode.Title) {
        return null;
    }

    return (
        <div data-qa="resume-search-context-subtitle-without-vacancy">
            <VSpacing default={8} />
            <ElementShownAnchor fn={sendEventElementShown} {...analyticsParams}>
                <Text Element="span" typography="label-2-regular">
                    {trls[TrlKeys.text]}
                </Text>
                <HSpacing default={8} />
                <Link
                    inline
                    typography="label-2-regular"
                    onClick={() => {
                        dispatch(setContextVacancySelectorVisible(true));
                        sendEventAction(ResumeSearchContextAction.Select, analyticsParams);
                    }}
                    data-qa="resume-search-context-action-select"
                >
                    {trls[TrlKeys.actionSelect]}
                </Link>
            </ElementShownAnchor>
        </div>
    );
};

export default translation(ContextSubtitleWithoutVacancy);
